import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from 'design-system-web';
import { M, S } from 'components/typography';

import styles from './styles.scss';

type Props = {
  teamCount: number;
  channelCount: number;
  selectedPermissionLabels: string[];
  isSubmitting: boolean;
  submitError: string | null;
  onConfirm: () => void;
  onBack: () => void;
  onClose: () => void;
};

export function ReviewConfirmStep({
  teamCount,
  channelCount,
  selectedPermissionLabels,
  isSubmitting,
  submitError,
  onConfirm,
  onBack,
  onClose,
}: Props) {
  const { t } = useTranslation();

  return (
    <div>
      <M mb={2} data-test="reviewSummary">
        {t(
          'web.admin.portalManagement.bulkTeamManagement.assignPermission.wizard.reviewStep.summary',
          { teamCount, channelCount }
        )}
      </M>
      <ul className={styles.permissionsList}>
        {selectedPermissionLabels.map(label => (
          <li key={label}>{label}</li>
        ))}
      </ul>

      {submitError && <S data-test="reviewError">{submitError}</S>}

      <div className={styles.footer}>
        <Button
          variant="secondary"
          onClick={onClose}
          testId="wizardCloseButton"
          disabled={isSubmitting}
        >
          {t(
            'web.admin.portalManagement.bulkTeamManagement.assignPermission.wizard.close'
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={onBack}
          testId="wizardBackButton"
          disabled={isSubmitting}
        >
          {t(
            'web.admin.portalManagement.bulkTeamManagement.assignPermission.wizard.back'
          )}
        </Button>
        <Button
          disabled={isSubmitting}
          loading={isSubmitting}
          onClick={onConfirm}
          testId="wizardConfirmButton"
        >
          {t(
            'web.admin.portalManagement.bulkTeamManagement.assignPermission.wizard.confirm'
          )}
        </Button>
      </div>
    </div>
  );
}
